import styles from './styles.module.css';

import {
    IoDiamondOutline,
    IoEyeOutline,
    IoMegaphoneOutline
} from 'react-icons/io5';

function About() {
    return (
        <article className={`${styles.about} `}>
            <div className='container'>


                <div className="row">
                    {/* ========================
                    INTRO
                ======================== */}
                    <div className="col-12 col-lg-10 m-auto">
                        <div className={styles.mainContent}>
                            <h4 className={styles.mainTitle}>
                                عن الرقيم المحاسبي
                            </h4>

                            <p className={styles.mainText}>
                                تأسست شركة الرقيم المحاسبي بصورتها الحالية في أكتوبر 2021،
                                وتقوم على خبرة علمية وعملية متراكمة لمؤسسيها في مجالات المحاسبة
                                والمراجعة والاستشارات المالية. يقود الشركة الأستاذ خالد الفيتوري
                                بصفته المدير العام، ويشغل منصب مدير العمليات الدكتور محمد عمر
                                عبدالرحيم، المحاسب والمراجع القانوني والخبير الحسابي المقيد
                                بالمحاكم الليبية، وأحد الأعضاء المقيدين بنقابة المحاسبين،
                                والحاصل على إذن مزاولة المهنة رقم 1443 لسنة 2007.
                                <br /><br />
                                وتسعى الشركة إلى تقديم خدمات محاسبية احترافية تعتمد على الدقة
                                والالتزام بالمعايير المهنية، بما يساهم في دعم متخذي القرار
                                وتعزيز الشفافية المالية داخل الوحدات الاقتصادية في البيئة المحلية.
                            </p>

                            <div className={styles.underline}></div>
                        </div>
                    </div>

                    <div className="w-100"></div>

                    {/* ========================
                    VALUES
                ======================== */}
                    <div className="col-12 col-md-4">
                        <div className={styles.item}>
                            <div className={styles.icon}>
                                <IoDiamondOutline size={65} />
                            </div>
                            <div className={styles.itemTitle}>
                                <h4>قيمنا</h4>
                            </div>
                            <div className={styles.itemText}>
                                نؤمن بالمهنية والموضوعية والاستقلالية، ونعتمد التطوير
                                والتدريب المستمر كمنهج أساسي لضمان جودة الأداء والالتزام
                                بأعلى المعايير المهنية.
                            </div>
                        </div>
                    </div>

                    {/* ========================
                    VISION
                ======================== */}
                    <div className="col-12 col-md-4">
                        <div className={styles.item}>
                            <div className={styles.icon}>
                                <IoEyeOutline size={65} />
                            </div>
                            <div className={styles.itemTitle}>
                                <h4>رؤيتنا</h4>
                            </div>
                            <div className={styles.itemText}>
                                أن نكون الشريك المحاسبي الموثوق للمشروعات والمؤسسات،
                                انطلاقًا من إيماننا بأن وراء كل مشروع ناجح منظومة مالية
                                ومحاسبية ناجحة.
                            </div>
                        </div>
                    </div>

                    {/* ========================
                    MISSION
                ======================== */}
                    <div className="col-12 col-md-4">
                        <div className={styles.item}>
                            <div className={styles.icon}>
                                <IoMegaphoneOutline size={65} />
                            </div>
                            <div className={styles.itemTitle}>
                                <h4>رسالتنا</h4>
                            </div>
                            <div className={styles.itemText}>
                                تقديم خدمات محاسبية واستشارية متكاملة تساهم في بناء
                                وحدات اقتصادية قوية ومستدامة، وصولًا إلى اقتصاد أكثر
                                كفاءة ومجتمع أكثر رفاهية.
                            </div>
                        </div>
                    </div>

                    {/* ========================
                    GOALS TITLE
                ======================== */}
                    <div className="col-12 mt-md-5">
                        <div className={`${styles.item} ${styles.goals}`}>
                            <div className={`${styles.itemTitle} ${styles.goalsTitle}`}>
                                <h4>أهدافنا</h4>
                            </div>
                            <div className={`${styles.itemText} ${styles.goalsText}`}>
                                تهدف الشركة إلى تقديم منظومة متكاملة من الخدمات
                                المحاسبية والمالية، بما يساهم في تحقيق العدالة
                                والشفافية وتحسين كفاءة الأداء داخل الوحدات
                                الاقتصادية في البيئة المحلية، وذلك من خلال:
                            </div>
                        </div>
                    </div>

                    {/* ========================
                    GOALS LIST
                ======================== */}
                    <div className="col-12 px-md-5 m-auto">
                        <ul className={styles.list}>
                            <li>
                                المساهمة في توفير بيئة عمل مالية سليمة للمؤسسات
                                الاقتصادية من خلال تقديم الاستشارات المهنية وتوفير
                                المعلومات المالية الدقيقة لدعم اتخاذ القرارات الرشيدة.
                            </li>
                            <li>
                                الإسهام في تطوير مهنة المحاسبة عبر تطبيق المعايير
                                المحاسبية الدولية والاسترشاد بأفضل الممارسات العالمية
                                بما يتوافق مع خصوصية البيئة الليبية.
                            </li>
                            <li>
                                تنمية مهارات الكوادر المحاسبية من خلال تنفيذ برامج
                                تدريبية متخصصة في مجالات المحاسبة والمالية والمراجعة.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </article>
    );
}

export default About;
